import { useSyncExternalStore } from "react";

/** Маршруты на History API: хэш занят Telegram (tgWebAppData) */
export type Route =
  | { name: "library" }
  | { name: "new" }
  | { name: "edit"; id: string }
  | { name: "play"; id: string }
  | { name: "settings" }
  | { name: "trainers" }
  | { name: "history" }
  | { name: "working"; id: string };

export function parse(path: string): Route {
  let m: RegExpExecArray | null;
  if (path === "/new") return { name: "new" };
  if (path === "/settings") return { name: "settings" };
  if (path === "/trainers") return { name: "trainers" };
  if (path === "/trainers/history") return { name: "history" };
  if ((m = /^\/workings\/([0-9a-f-]{36})$/.exec(path))) return { name: "working", id: m[1]! };
  if ((m = /^\/sets\/([0-9a-f-]{36})\/edit$/.exec(path))) return { name: "edit", id: m[1]! };
  if ((m = /^\/sets\/([0-9a-f-]{36})$/.exec(path))) return { name: "play", id: m[1]! };
  return { name: "library" };
}

export function href(r: Route): string {
  switch (r.name) {
    case "library":
      return "/";
    case "new":
      return "/new";
    case "settings":
      return "/settings";
    case "edit":
      return `/sets/${r.id}/edit`;
    case "play":
      return `/sets/${r.id}`;
    case "trainers":
      return "/trainers";
    case "history":
      return "/trainers/history";
    case "working":
      return `/workings/${r.id}`;
  }
}

const listeners = new Set<() => void>();
const notify = () => listeners.forEach((l) => l());
window.addEventListener("popstate", notify);

/** Глубина внутри приложения: «назад» не должен уводить на чужую страницу или about:blank */
const depth = () => (history.state as { depth?: number } | null)?.depth ?? 0;

export function navigate(r: Route, opts: { replace?: boolean } = {}) {
  const url = href(r);
  if (url === location.pathname) return;
  if (opts.replace) history.replaceState({ depth: depth() }, "", url);
  else history.pushState({ depth: depth() + 1 }, "", url);
  notify();
}

export function back() {
  if (depth() > 0) history.back();
  else navigate({ name: "library" }, { replace: true });
}

export function useRoute(): Route {
  const path = useSyncExternalStore(
    (cb) => {
      listeners.add(cb);
      return () => listeners.delete(cb);
    },
    () => location.pathname,
  );
  return parse(path);
}
